import { Flex } from '@mantine/core';
import { StepProps } from 'src/UI/drawer-flow/DrawerFlow';
import DrawerFlowScreenLayout from 'src/UI/drawer-flow/DrawerFlowScreenLayout';
import { Company, useCompanies } from 'src/secret-menu/hooks/useCompanies';
import PageLoader from 'src/UI/loader/PageLoader';
import { GenericErrorPage } from 'src/error/GenericErrorPage';
import { TemplateCreationData } from 'src/company/templates/types';
import {
  SelectableList,
  SELECTION_MODE,
} from 'src/common/components/selectable-list/SelectableList';

export default function SelectCompanyStep(props: StepProps<TemplateCreationData>) {
  const { companies, isLoading, isError, error } = useCompanies();
  const { company } = props.data;

  if (isError) {
    return <GenericErrorPage error={error} />;
  }

  if (isLoading || !companies) {
    return <PageLoader />;
  }

  return (
    <DrawerFlowScreenLayout
      {...props}
      title="Select company"
      description={'Select the company you wish to generate the template for'}
      canGoForward={props.canGoForward}
      clientNameSuffix="agenda"
    >
      <Flex direction="column" mih={0} h="100%" style={{ flexShrink: 1, flexGrow: 0 }}>
        <SelectableList
          items={companies}
          selectionMode={SELECTION_MODE.SINGLE}
          selectedItems={[company]}
          onSelectItem={(company: Company) => {
            props.setData({ ...props.data, company });
          }}
          getItemId={(company: Company) => company.id}
          getItemLabel={(company: Company) => company.name}
          searchTermMatchFunction={(item: Company, searchTerm: string) => {
            return item.name.toLowerCase().includes(searchTerm.toLowerCase());
          }}
        />
      </Flex>
    </DrawerFlowScreenLayout>
  );
}
